export default {
	krsLabel: "KRs",
	ProgressLabel: "Progress",
	ConfidenceLabel: "Confidence",
	lastUpdatedLabel: "updated {lastUpdated}",
};
